var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 10,
    viewBox: "0 0 30 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66173 10C2.70054 10 1.87775 9.67818 1.19335 9.03455C0.508948 8.39091 0.166748 7.61712 0.166748 6.71318V1.36364C0.166748 0.977273 0.305787 0.653333 0.583865 0.391818C0.861943 0.130606 1.2064 0 1.61723 0C2.02839 0 2.37268 0.130606 2.65011 0.391818C2.92787 0.653333 3.06675 0.977273 3.06675 1.36364V6.71318C3.06675 6.87652 3.12249 7.01061 3.23398 7.11546C3.34547 7.2203 3.48805 7.27273 3.66173 7.27273H25.6718C25.8454 7.27273 25.988 7.2203 26.0995 7.11546C26.211 7.01061 26.2667 6.87652 26.2667 6.71318V1.36364C26.2667 0.977273 26.4058 0.653333 26.6839 0.391818C26.9619 0.130606 27.3064 0 27.7172 0C28.1284 0 28.4727 0.130606 28.7501 0.391818C29.0279 0.653333 29.1667 0.977273 29.1667 1.36364V6.71318C29.1667 7.61712 28.8245 8.39091 28.1401 9.03455C27.4557 9.67818 26.633 10 25.6718 10H3.66173Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpace);
export default __webpack_public_path__ + "static/media/space.caeb6a88527495f6ea764ddabe67bbf9.svg";
export { ForwardRef as ReactComponent };